export default __webpack_public_path__ + "5bd96aa28200f7b19612bb721148e369.png";